import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col, Input, Button, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';

const CUSTOMER_USERNAME = localStorage.getItem("username");
const COMPANY_ID = localStorage.getItem("company_id");

const EditPropModal = ({ visible, onCancel, onSuccess, itemToEdit }) => {
  const [form] = Form.useForm();
  const [editButtonLoader, setEditButtonLoader] = useState(false);

  useEffect(() => {
    if (visible && itemToEdit) {
      // Set initial form values
      form.setFieldsValue({
        name: itemToEdit.name || '',
        category: itemToEdit.category || ''
      });
    } else if (!visible) {
      form.resetFields();
    }
  }, [visible, itemToEdit, form]);

  const handleEditSave = async (values) => {
    if (!itemToEdit) return;
    
    setEditButtonLoader(true);
    try {
      const payload = {
        action: 'update_prop',
        prop_id: itemToEdit.id,
        name: values.name,
        category: values.category,
        username: CUSTOMER_USERNAME,
        company_id: COMPANY_ID
      };

      const response = await axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload);

      if (response.data && response.data.result === 'success') {
        message.success('Prop updated successfully');
        window.location.reload();
      } else {
        message.error('Failed to update prop');
      }
    } catch (error) {
      console.error("Error updating prop:", error);
      message.error('Error updating prop');
    } finally {
      setEditButtonLoader(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      visible={visible}
      className="template-modal-setting small-40"
      width={788}
      maskClosable={false}
      closable={true}
      destroyOnClose={true}
      title={<span className="manrope f-14 lh-22 w-700 black-085">
        Edit</span>}
      onCancel={handleCancel}
      footer={[
        <div className="justify-in-end" key="footer">
          <Button disabled={editButtonLoader} className="modal-okay square font-14" onClick={() => form.submit()}>
            Save&nbsp;{editButtonLoader ? <LoadingOutlined /> : ''}
          </Button>
        </div>
      ]}
    >
      <Row>
        <Col span={24}>
          <Form
            form={form}
            onFinish={handleEditSave}
            layout="vertical"
          >
            <Row type='flex' gutter={12}>
              <Col span={24} style={{ marginBottom: 10 }}>
                <Form.Item
                  colon={false}
                  label={<span className="manrope f-14 black-55">Name</span>}
                  name="name"
                  rules={[
                    { required: true, message: 'Please enter prop name.' },
                    { whitespace: true, message: 'Name cannot be blank.' }
                  ]}
                >
                  <Input
                    disabled={editButtonLoader}
                    placeholder="Enter prop name"
                    className="manrope f-14 black-55"
                    style={{width: "100%", height:"40px"}}
                  />
                </Form.Item>
              </Col>
              <Col span={24} style={{ marginBottom: 10 }}>
                <Form.Item
                  colon={false}
                  label={<span className="manrope f-14 black-55">Category</span>}
                  name="category"
                  rules={[
                    { whitespace: true, message: 'Category cannot be blank.' }
                  ]}
                >
                  <Input
                    disabled={editButtonLoader}
                    placeholder="Enter category"
                    className="manrope f-14 black-55"
                    style={{width: "100%", height:"40px"}}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Modal>
  );
};

export default EditPropModal;

